"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var Box_1 = require("../Box");
var animatedBoxProperty = function (direction) { return (direction === 'horizontal' ? 'width' : 'height'); };
var AnimatedBox = styled_components_1.default(Box_1.Box)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    return !props.animate &&
        (props.open
            ? "\n    max-" + animatedBoxProperty(props.collapsibleDirection) + ": unset;\n    visibility: visible;\n  "
            : "\n    max-" + animatedBoxProperty(props.collapsibleDirection) + ": 0;\n    visibility: hidden;\n  ");
});
var Collapsible = /** @class */ (function (_super) {
    tslib_1.__extends(Collapsible, _super);
    function Collapsible(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.ref = React.createRef(); // Global
        _this.getSnapshotBeforeUpdate = function () { return _this.ref.current && _this.ref.current.getBoundingClientRect(); };
        _this.state = { open: props.open, animate: false };
        return _this;
    }
    Collapsible.getDerivedStateFromProps = function (nextProps, prevState) {
        var open = nextProps.open;
        if (open !== prevState.open) {
            return {
                animate: true,
                open: open
            };
        }
        return null;
    };
    Collapsible.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var _this = this;
        var _a = this.props, direction = _a.direction, _b = _a.theme.collapsible, minSpeed = _b.minSpeed, baseline = _b.baseline;
        var _c = this.state, animate = _c.animate, open = _c.open;
        var container = this.ref.current;
        if (container) {
            var dimension_1 = animatedBoxProperty(direction);
            var boudingClientRect = container.getBoundingClientRect();
            var dimensionSize_1 = boudingClientRect[dimension_1];
            var shouldAnimate = animate && prevState.open !== open;
            if (open && snapshot[dimension_1] && dimensionSize_1 !== snapshot[dimension_1]) {
                shouldAnimate = true;
            }
            if (shouldAnimate) {
                if (this.animationTimeout) {
                    clearTimeout(this.animationTimeout);
                }
                var speed_1 = Math.max((dimensionSize_1 / baseline) * minSpeed, minSpeed);
                container.style["max-" + dimension_1] = snapshot[dimension_1] + "px";
                container.style.overflow = 'hidden';
                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        container.style.transition = "max-" + dimension_1 + " " + speed_1 + "ms, visibility 50ms";
                        container.style["max-" + dimension_1] = open ? dimensionSize_1 + "px" : '0px';
                        _this.animationTimeout = setTimeout(function () {
                            container.removeAttribute('style');
                            _this.setState({
                                animate: false
                            });
                        }, speed_1);
                    });
                });
            }
        }
    };
    Collapsible.prototype.componentWillUnmount = function () {
        if (this.animationTimeout) {
            clearTimeout(this.animationTimeout);
        }
    };
    Collapsible.prototype.render = function () {
        /* eslint-disable-next-line react/prop-types */
        var _a = this.props, children = _a.children, direction = _a.direction;
        var _b = this.state, animate = _b.animate, open = _b.open;
        return (React.createElement(AnimatedBox, { "aria-hidden": !open, ref: this.ref, open: open, animate: animate, collapsibleDirection: direction }, open || animate ? children : ''));
    };
    return Collapsible;
}(React.Component));
var CollapsibleWrapper = recompose_1.compose(styled_components_1.withTheme)(Collapsible);
exports.Collapsible = CollapsibleWrapper;
var templateObject_1;
//# sourceMappingURL=Collapsible.js.map